import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getAcceptedMimetypes } from '../../../services/mimetypes/mimetypesService';

const styles = {
  attachmentRow: {
    marginLeft: '1em',
    marginRight: '1em',
    justifyContent: 'space-between'
  },
  dropZoneCustomCardsScroll: {
    display: 'flex',
    overflowX: 'auto',
    padding: '24px 0'
  },
  dropZoneCustomCard: {
    margin: '0 8px',
    position: 'relative'
  },
  dropZoneCustomImage: {
    alignItems: 'center',
    backgroundColor: '#ccc',
    borderRadius: '20px',
    display: 'flex',
    height: '170px',
    justifyContent: 'center',
    minWidth: '255px',
    overflow: 'hidden',
    width: '255px'
  },
  dropZoneCustomText: {
    color: '#333',
    fontSize: '14px',
    margin: '16px 0 0 0',
    padding: '0 12px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    webkitBoxOrient: 'vertical',
    webkitLineClamp: '1',
    width: '255px'
  },
  dropZoneCustomButton: {
    alignItems: 'center',
    backgroundColor: 'rgba(24,148,210,0.1)',
    borderRadius: '8px',
    color: '#1894D2',
    height: '170px',
    margin: '0 8px',
    minWidth: '42px',
    width: '42px'
  },
  dropZoneContainer: {
    background: '#fff',
    borderBottom: '1px solid #ccc',
    margin: '24px 0 0',
    padding: '0 16px'
  },
  removeButton: {
    backgroundColor: '#12ABE3',
    borderRadius: '50%',
    color: '#fff',
    fontSize: '14px',
    height: '32px',
    position: 'absolute',
    right: '-8px',
    top: '-8px',
    width: '32px'
  }
};

class FileViewBox extends Component {
  static propTypes = {
    classes: PropTypes.object,
    defaultIcon: PropTypes.string,
    files: PropTypes.array,
    canChange: PropTypes.bool,
    onDeleteFileEvalFile: PropTypes.func,
    showLoader: PropTypes.bool,
    mimetypePolicy: PropTypes.string,
    mimetypes: PropTypes.string,
    disableClick: PropTypes.bool,
    onDrop: PropTypes.func
  };

  onDeleteFileEvalFile = (e, index) => {
    e.stopPropagation();
    this.props.onDeleteFileEvalFile(e, index);
  };

  renderDropContainerFile = () => {
    const { disableClick, defaultIcon, classes, files } = this.props;
    return (
      <div className={`${classes.dropZoneCustomCardsScroll}`}>
        {files.length &&
          files.map((file, index) => {
            return (
              <div key={index} className={`${classes.dropZoneCustomCard}`}>
                <img
                  className={`${classes.dropZoneCustomImage}`}
                  alt=""
                  src={file.preview}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = defaultIcon;
                  }}
                />
                <p className={`${classes.dropZoneCustomText}`}>{file.fileName || file.name}</p>
                {!disableClick && (
                  <div className="file-buttons">
                    <button className={`${classes.removeButton}`} onClick={e => this.onDeleteFileEvalFile(e, index)}>
                      <i className="close custom-icons-close-button"></i>
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        <button className={`${classes.dropZoneCustomButton}`}>
          <i className="custom-icons-plus-button"></i>
        </button>
      </div>
    );
  };

  renderNormalFileViewBox = (classes, defaultIcon, filesUploaded, files) => {
    return (
      <div className={`${classes.dropZoneCustomCardsScroll}`}>
        {filesUploaded &&
          files.map((file, index) => {
            return (
              <div key={index} className={`${classes.dropZoneCustomCard}`}>
                <a target="_blank" rel="noopener noreferrer" href={file.url}>
                  <img
                    className={`${classes.dropZoneCustomImage}`}
                    alt=""
                    src={file.preview || file.url}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = defaultIcon;
                    }}
                  />
                </a>
                <div className={`${classes.dropZoneCustomText}`}>{file.fileName || file.name}</div>
              </div>
            );
          })}
      </div>
    );
  };

  render() {
    const { classes, defaultIcon, files, canChange, mimetypes, mimetypePolicy, showLoader } = this.props;
    const filesUploaded = files.length > 0;

    return (
      <div className={`${classes.dropZoneContainer}`}>
        {canChange && showLoader && (
          <div className="drop-container">
            <CircularProgress />
          </div>
        )}
        {canChange && !showLoader && (
          <Dropzone
            multiple={true}
            disablePreview={false}
            accept={getAcceptedMimetypes(mimetypes, mimetypePolicy)}
            onDrop={files => this.props.onDrop(files)}
            style={{ width: '100%' }}
          >
            {this.renderDropContainerFile()}
          </Dropzone>
        )}
        {!canChange && !showLoader && this.renderNormalFileViewBox(classes, defaultIcon, filesUploaded, files)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors,
    defaultIcon: state.theme.images.placeholders.attachmentIcon,
    mimetypePolicy: state.account.configuration.mimetypePolicy,
    mimetypes: state.account.configuration.mimetypes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(FileViewBox));
